import { useContext } from 'react';
import LogoImg from './../../assets/img/vinod-logo.png';
import LogoImgLight from './../../assets/img/vinod-white-feet-logo.png';
import { ThemeContext } from '../../Theme';
import styled from 'styled-components';

const LogoWrapper = styled.div`
.my-logo {
    @media screen and (max-width: 480px) {
        font-size: 12px !important;
    }
}
`
function Logo () {
    const { theme } = useContext(ThemeContext);

    return (  
        <LogoWrapper>
            <p className="my-logo">
            {
            theme === 'dark-theme' ? 
            <img src={LogoImgLight} alt="vinod soba freelance web developer" /> 
            :
            <img src={LogoImg} alt="vinod soba freelance web developer" /> 
            
            } Vinod Soba</p>
        </LogoWrapper>
    );
}

export default Logo ;